import { GetIdeaResponse, PutIdeaType } from '@orbit/api-types'
import api from '@lib/api'
import { queryKeys } from '@lib/queryKeys'
import { createTripMutation } from './createTripCrudResource'

export const useUpdateIdea = createTripMutation<
	GetIdeaResponse,
	{ tripId: string; ideaId: string; ideaData: PutIdeaType }
>({
	mutationFn: async ({ ideaId, ideaData }) => {
		const response = await api.patch<GetIdeaResponse>(`/ideas/${ideaId}`, ideaData)
		return response.data
	},
	invalidate: ({ tripId }) => [queryKeys.ideas(tripId)],
})
